import styled from "styled-components";
import { PrimaryButton } from "../../Buttons/PrimaryButton/PrimaryButton";

export const LoginButtonContainer = styled(PrimaryButton)`
  height: 49px;
  width: 180px;
  font-weight: 600;
  margin-right: 10px;
`;
